import { useContext, useState } from 'react';
import useSignalRSubscription from '../../../signalR/useSignalRSubscription';
import { PageLoadingContext } from '../../loader/contexts/PageLoadingContext';
import { showErrorToast } from '@shared/services/toastService';
import { useLoadingToast } from './useLoadingToast';
import { blobStorageUploadFile } from '@shared/services/blobStorageService';

export const useNonBlockingFileUpload = props => {
  const {
    loadingMessage,
    successMessage,
    errorMessage,
    signalRMessageTarget,
    errorCodeToMessagesMap = null,
    onSuccess = null
  } = props;

  const { executeWithLoadingIndicator } = useContext(PageLoadingContext);
  const [uploadFileLoading, setUploadFileLoading] = useState(false);

  const {
    show: showLoadingToaster,
    updateToSucess: updateToSucessToaster,
    updateToError: updateToErrorToaster
  } = useLoadingToast(loadingMessage);

  const resolvePromiseNotification = notification => {
    if (!isNotificationSuccessful(notification)) {
      const errorCode = notification.notificationData?.errorMessageCode;
      setUploadFileLoading(false);
      updateToErrorToaster(
        errorCodeToMessagesMap ? errorCodeToMessagesMap[errorCode] : errorMessage
      );
      return;
    }

    updateToSucessToaster(successMessage);

    if (onSuccess) {
      onSuccess();
    }
  };

  useSignalRSubscription(signalRMessageTarget, resolvePromiseNotification);

  const uploadFile = async (file, fileUrlProvider) => {
    setUploadFileLoading(true);

    await executeWithLoadingIndicator(async () => {
      const fileUrl = await fileUrlProvider();
      const result = await blobStorageUploadFile(fileUrl, file);

      if (!result) {
        showErrorToast(errorMessage);
        return;
      }

      showLoadingToaster();
    });
  };

  return {
    uploadFile,
    uploadFileLoading
  };
};

const isNotificationSuccessful = notification => notification.notificationData?.success;
